import React, { useState } from 'react';
import {
  Grid,
  Menu,
  MenuItem,
  makeStyles,
  Divider,
  colors,
  Typography,
} from '@material-ui/core';

import Routes from 'config/routes';

import Description from 'components/typography/Description';
import Link from 'components/Link';

const useStyles = makeStyles({
  userName: {
    color: colors.red[400],
    fontFamily: 'Pacifico,cursive',
  },
  header: {
    padding: 16,
  },
  body: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  item: {
    width: '100%',
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  itemText: {
    fontFamily: 'Fredoka One, cursive',
    color: 'rgba(0, 0, 0, 0.64)',
  },
  signOutButton: {
    color: colors.red[400],
  },
});

const ProfileMenu = ({ renderButton, userName = '', email = '' }) => {
  const classes = useStyles();
  const [profileMenu, setProfileMenu] = useState(null);

  const _onProfileButtonClick = (event) => setProfileMenu(event.currentTarget);
  const _onClose = () => setProfileMenu(null);

  return (
    <React.Fragment>
      {renderButton(_onProfileButtonClick)}
      <div>
        <Menu
          keepMounted
          anchorEl={profileMenu}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={!!profileMenu}
          onClose={_onClose}
          style={{ marginTop: 8 }}
        >
          <Grid container direction="column">
            <Grid item container className={classes.header} direction="column">
              <Grid item container>
                <Typography variant="h4">
                  <span className={classes.userName}>{userName}</span>
                </Typography>
              </Grid>

              <Grid item container style={{ marginTop: 8 }} justify="flex-end">
                <Description>{email}</Description>
              </Grid>
            </Grid>

            <Grid item>
              <Divider></Divider>
            </Grid>

            <Grid item container direction="column" className={classes.body}>
              <Grid item container>
                <Link pathname={Routes.createRecipe()} className={classes.item}>
                  <MenuItem onClick={_onClose} component="div">
                    <Typography variant="h6">
                      <span className={classes.itemText}>Create recipe</span>
                    </Typography>
                  </MenuItem>
                </Link>
              </Grid>

              <Grid item container>
                <Link pathname={Routes.MY_RECIPES} className={classes.item}>
                  <MenuItem onClick={_onClose} component="div">
                    <Typography variant="h6">
                      <span className={classes.itemText}>My recipes</span>
                    </Typography>
                  </MenuItem>
                </Link>
              </Grid>
            </Grid>

            <Grid item>
              <Divider></Divider>
            </Grid>

            <Grid item container direction="column" className={classes.body}>
              <Grid item container>
                <Link pathname={Routes.BOOKMARKS} className={classes.item}>
                  <MenuItem onClick={_onClose} component="div">
                    <Typography variant="h6">
                      <span className={classes.itemText}>Bookmarked</span>
                    </Typography>
                  </MenuItem>
                </Link>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Divider></Divider>
          </Grid>

          <Grid item container className={classes.body}>
            <Link pathname={Routes.LOGOUT} className={classes.item}>
              <MenuItem className={classes.item}>
                <Grid container justify="flex-end">
                  <b className={classes.signOutButton}>SIGN OUT</b>
                </Grid>
              </MenuItem>
            </Link>
          </Grid>
        </Menu>
      </div>
    </React.Fragment>
  );
};

export default ProfileMenu;
